import React, { useState, useEffect } from 'react';
import { Container, Button, Badge, Spinner } from 'react-bootstrap';
import { FaGem, FaSatellite, FaArrowRight, FaShieldAlt, FaUserCheck } from 'react-icons/fa';
import api from '../services/api';

const AgencyLanding = ({ slug, setCurrentView }) => {
    const [agencyInfo, setAgencyInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAgencyData = async () => {
            try {
                const res = await api.get(`/public/agency-info/${slug}`);
                if (res.data.success) {
                    setAgencyInfo(res.data.agency);
                }
            } catch (err) {
                console.error("Lỗi tải thông tin đại lý:", err);
            } finally {
                setLoading(false);
            }
        };
        if (slug) fetchAgencyData();
    }, [slug]);

    const handleRegisterAction = () => {
        if (slug) {
            // 1. Ghi nhận khách hàng thuộc về đại lý này vào LocalStorage
            localStorage.setItem('referred_by_agency', slug.toLowerCase().trim());
            console.log("🔗 Hệ thống đã ghim mã đại lý:", slug);
        }
        // Chuyển hướng sang trang đăng ký chuẩn
        setCurrentView('register');
    };

    if (loading) return (
        <div className="d-flex justify-content-center align-items-center vh-100" style={{background:'#020617'}}>
            <Spinner animation="border" variant="warning" />
        </div>
    );

    return (
        <div className="agency-landing-minimal">
            <div className="grid-overlay"></div>
            
            <Container className="d-flex align-items-center justify-content-center min-vh-100">
                <div className="content-wrapper text-center">
                    {/* Badge hiệu ứng vệ tinh */}
                    <div className="d-inline-flex align-items-center mb-4 px-4 py-2 glass-badge border border-warning border-opacity-20 rounded-pill">
                        <FaSatellite className="text-warning me-2 animate-flicker" />
                        <span className="font-mono text-warning small fw-bold tracking-widest uppercase">
                            NEXBOT_OFFICIAL_PARTNER
                        </span>
                    </div>

                    {/* Hiển thị tên đại lý sang trọng */}
                    <div className="brand-section mb-5">
                        <h1 className="agency-name-display">
                            {agencyInfo?.agencyName || "NEXBOT AGENT"}
                        </h1>
                        <div className="gold-separator"></div>
                        <p className="welcome-text">
                            Chào mừng bạn đến với hệ thống giao dịch của đối tác <br/>
                            <strong className="text-warning text-uppercase">{agencyInfo?.agencyName}</strong>
                        </p>
                    </div>

                    {/* Card hành động chính */}
                    <div className="action-card p-5 border border-white border-opacity-10 shadow-2xl">
                        <div className="icon-main mb-4">
                            <FaGem size={60} className="text-warning gem-pulse" />
                        </div>
                        <h2 className="text-white fw-black mb-4 uppercase tracking-tighter" style={{fontSize: '1.5rem'}}>
                            Fight together, win together.
                        </h2>
                        <p className="text-white-50 mb-5 mx-auto" style={{maxWidth: '450px'}}>
                            Kiến tạo cuộc sống tự do tài chính cùng NeXBot
                        </p>
                        
                        <Button onClick={handleRegisterAction} className="btn-register-luxury">
                             ĐĂNG KÝ 
                        </Button>

                        <div className="mt-5 d-flex align-items-center justify-content-center gap-4 text-white-50 small font-mono">
                            <span><FaShieldAlt className="text-success me-1"/> SECURE_SSL</span>
                            <span><FaUserCheck className="text-info me-1"/> VERIFIED_AGENT</span>
                        </div>
                    </div>
                </div>
            </Container>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@800;900&family=Fira+Code:wght@400;600&family=Inter:wght@300;400;700&display=swap');
                
                .agency-landing-minimal { 
                    font-family: 'Inter', sans-serif; 
                    background: radial-gradient(circle at center, #0b1221 0%, #020617 100%);
                    color: #f8fafc; 
                    position: relative; overflow: hidden;
                }

                .grid-overlay {
                    position: absolute; top: 0; left: 0; width: 100%; height: 100%;
                    background-image: linear-gradient(rgba(234, 179, 8, 0.03) 1px, transparent 1px), 
                                      linear-gradient(90deg, rgba(234, 179, 8, 0.03) 1px, transparent 1px);
                    background-size: 60px 60px; z-index: 1; pointer-events: none;
                }

                .content-wrapper { position: relative; z-index: 2; width: 100%; padding: 2rem 0; }

                .agency-name-display {
                    font-family: 'Montserrat', sans-serif;
                    font-size: clamp(2.5rem, 7vw, 5rem);
                    font-weight: 900;
                    background: linear-gradient(135deg, #eab308 0%, #fff 50%, #eab308 100%);
                    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
                    text-transform: uppercase; letter-spacing: -2px; margin-bottom: 0.5rem;
                }

                .gold-separator {
                    width: 80px; height: 4px; background: #eab308;
                    margin: 1.5rem auto; box-shadow: 0 0 20px rgba(234, 179, 8, 0.6);
                }

                .welcome-text { font-size: 1.1rem; color: rgba(255,255,255,0.6); line-height: 1.6; }

                .action-card {
                    background: rgba(255, 255, 255, 0.02);
                    backdrop-filter: blur(20px);
                    border-radius: 30px;
                    max-width: 650px;
                    margin: 0 auto;
                }

                .glass-badge {
                    background: rgba(0,0,0,0.5);
                    font-family: 'Fira Code', monospace;
                }

                .btn-register-luxury {
                    background: linear-gradient(135deg, #eab308 0%, #ca8a04 100%);
                    color: #000; font-family: 'Montserrat', sans-serif;
                    font-weight: 900; padding: 20px 50px; border: none;
                    border-radius: 15px; font-size: 1.2rem; transition: 0.3s;
                    box-shadow: 0 10px 30px rgba(234, 179, 8, 0.3);
                }

                .btn-register-luxury:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 40px rgba(234, 179, 8, 0.5);
                    background: #facc15;
                }

                .gem-pulse { animation: pulse-gold 2s infinite; }
                @keyframes pulse-gold {
                    0% { transform: scale(1); filter: drop-shadow(0 0 0px #eab308); }
                    50% { transform: scale(1.05); filter: drop-shadow(0 0 15px #eab308); }
                    100% { transform: scale(1); filter: drop-shadow(0 0 0px #eab308); }
                }

                .animate-flicker { animation: flicker 3s infinite; }
                @keyframes flicker {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.3; }
                }

                @media (max-width: 768px) {
                    .action-card { padding: 2.5rem 1.5rem; border-radius: 20px; margin: 0 1rem; }
                    .agency-name-display { font-size: 2.8rem; }
                }
            `}</style>
        </div>
    );
};

export default AgencyLanding;